export { default as ShortcutManager, registerAction } from './ShortcutManager';
export { actionStore } from './Store';
export type { ShortcutActionCallback, ShortcutAction } from './ShortcutManager.types';
